import FixedViewportElement from '@99designs/react-components/components/FixedViewportElement';

export default FixedViewportElement;



// WEBPACK FOOTER //
// ./~/@99designs/fullscreen/components/FixedViewportElement.js